/**
 * The levels of the console.
 * https://developer.mozilla.org/en-US/docs/Web/API/console
 */
export const CONSOLE_LEVELS = [
  'log',
  'warn',
  'error',
  'info',
  'debug',
  'assert',
] as const;

/**
 * Represents a specific level of the console.
 */
export type ConsoleLevel = (typeof CONSOLE_LEVELS)[number];

/**
 * Event of the console.
 */
export type ConsoleEvent = {
  timestamp: string;
  level: ConsoleLevel;
  message: string;
};
